import React from 'react';
import { ReactComponent as SearchIcon } from '../../shared/icons/search-icon.svg';
import styles from './GlobalSearchSlideout.module.scss';

interface EmptyStatesProps {
  type: 'initial' | 'min-chars' | 'loading' | 'no-results';
  query?: string;
}

export const EmptyStates: React.FC<EmptyStatesProps> = ({ type, query }) => {
  switch (type) {
    case 'initial':
      return (
        <div className={styles.emptyState}>
          <SearchIcon />
          <div className={styles.emptyStateTitle}>Search Propdocs</div>
          <div className={styles.emptyStateText}>
            Search across all your deals, documents, templates, clauses, contacts, and checklists.
          </div>
          <div className={styles.shortcutHint}>
            <span className={styles.shortcutKey}>⌘</span>
            <span className={styles.shortcutKey}>K</span>
            <span>to open search</span>
          </div>
        </div>
      );

    case 'min-chars':
      return (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateText}>Type at least 2 characters to search</div>
        </div>
      );

    case 'loading':
      return (
        <>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div style={{ flex: 1 }}>
                <div className={`${styles.skeletonLine} ${styles.skeletonLine__wide}`} />
                <div className={`${styles.skeletonLine} ${styles.skeletonLine__medium}`} />
              </div>
            </div>
          ))}
        </>
      );

    case 'no-results':
      return (
        <div className={styles.emptyState}>
          <SearchIcon />
          <div className={styles.emptyStateTitle}>No results found</div>
          <div className={styles.emptyStateText}>
            No results for &ldquo;{query}&rdquo;. Try a different search term or category.
          </div>
        </div>
      );

    default:
      return null;
  }
};
